/* eslint-disable */
import React from 'react'
import jMoment from 'moment-jalaali'
import InputMask from 'react-input-mask'
import moment from 'moment-jalali'

class FromToPicker extends React.Component {
  constructor(props) {
    super(props)

    if (this.props.defaulValue) {
      this.state = {
        fromValue: this.convertDigit(jMoment().format('jYYYY/jMM/jDD')),
        toValue: this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))
      }

      this.props.onChangeFromDate(this.epochFrom(this.state.fromValue))
      this.props.onChangeToDate(this.epochTo(this.state.toValue))
    } else if (this.props.initValue) {
      this.state = {
        fromValue: this.convertDigit(moment(this.props.queryValue).format('jYYYY/jMM/jDD')),
        toValue: this.convertDigit(moment(this.props.queryValue).format('jYYYY/jMM/jDD'))
      }

      this.props.onChangeFromDate(this.epochFrom(this.state.fromValue))
      this.props.onChangeToDate(this.epochTo(this.state.toValue))
    } else if (this.props.lastWeek) {
      this.state = {
        fromValue: this.convertDigit(
          jMoment()
            .subtract(7, 'days')
            .format('jYYYY/jMM/jDD')
        ),
        toValue: this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))
      }
      this.props.onChangeFromDate(this.epochFrom(this.state.fromValue))
      this.props.onChangeToDate(this.epochTo(this.state.toValue))
    } else if (this.props.lastMonth) {
      this.state = {
        fromValue: this.convertDigit(
          jMoment()
            .subtract(31, 'days')
            .format('jYYYY/jMM/jDD')
        ),
        toValue: this.convertDigit(jMoment().format('jYYYY/jMM/jDD'))
      }
      this.props.onChangeFromDate(this.epochFrom(this.state.fromValue))
      this.props.onChangeToDate(this.epochTo(this.state.toValue))
    } else {
      this.state = {
        fromValue: '',
        toValue: ''
      }
    }

    this.fromDate = React.createRef()
  }

  componentDidMount() {
    // alert(moment(1595359800000).format('jYYYY/jMM/jDD'))
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.defaulValue !== this.props.defaulValue) {
      this.setState({
        fromValue: '',
        toValue: ''
      })
      this.props.onChangeFromDate('')
      this.props.onChangeToDate('')
    }
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      console.log(from)
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  epochTo = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + '23:59:59'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  onChangeFrom = (event) => {
    this.setState(
      {
        fromValue: event.target.value
      },
      () => {
        if (this.state.fromValue === '') {
          this.props.onChangeFromDate('')
        } else {
          this.props.onChangeFromDate(this.epochFrom(this.state.fromValue))
        }
        if (
          this.state.fromValue.match(
            /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
          )
        ) {
          // this.fromDate.current.focus()
          let {fromId, toId} = this.props
          // document.getElementById(fromId).focus();
          document.getElementById(toId).focus()
          this.props.onChangeToDate(this.epochTo(this.state.fromValue))
          this.setState({
            toValue: this.state.fromValue
          })
        }
      }
    )
  }

  onChangeTo = (event) => {
    this.setState(
      {
        toValue: event.target.value
      },
      () => {
        if (this.state.toValue === '') {
          this.props.onChangeToDate('')
        } else {
          this.props.onChangeToDate(this.epochTo(this.state.toValue))
        }
      }
    )
  }

  beforeMaskedValueChangeFrom = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }
  beforeMaskedValueChangeTo = (newState, oldState, userInput) => {
    var {value} = newState
    var selection = newState.selection
    var cursorPosition = selection ? selection.start : null

    // keep minus if entered by user
    if (value.endsWith('-') && userInput !== '-' && !this.state.value.endsWith('-')) {
      if (cursorPosition === value.length) {
        cursorPosition--
        selection = {start: cursorPosition, end: cursorPosition}
      }
      value = value.slice(0, -1)
    }

    return {
      value,
      selection
    }
  }

  clearFromDate = () => {
    this.setState(
      {
        fromValue: ''
      },
      () => {
        this.props.onChangeFromDate('')
        let {fromId} = this.props
        document.getElementById(fromId).focus()
      }
    )
  }

  clearToDate = () => {
    this.setState(
      {
        toValue: ''
      },
      () => {
        this.props.onChangeToDate('')
        let {toId} = this.props
        document.getElementById(toId).focus()
      }
    )
  }

  changeFromHour = (e) => {
    let value = e.target.value
    this.props.onChangeFromHour(value)
  }
  changeToHour = (e) => {
    let value = e.target.value
    this.props.onChangeToHour(value)
  }

  render() {
    return (
      <React.Fragment>
        <div className="formComponent relativeComponent">
          <label className="labelComponent">
            {this.props.fromLabel}
            {this.props.forceStart ? <span className="text-danger mx-1">*</span> : null}
            <span style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}} className="requireFiled">
              *
            </span>
          </label>
          <InputMask
            autocomplete="off"
            placeholder="yyyy/mm/dd"
            id={this.props.fromId}
            className="form-control"
            mask="9999/99/99"
            maskChar={null}
            value={this.state.fromValue}
            onChange={this.onChangeFrom}
            beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}
          />
          <img
            onClick={() => this.clearFromDate()}
            src={require('../../image/close.svg')}
            style={{
              width: 20,
              position: 'absolute',
              top: 52,
              left: 15,
              cursor: 'pointer'
            }}
          />
        </div>
        {this.props.hasHour && (
          <div className="formComponent relativeComponent">
            <label className="labelComponent">
              {'ساعت از : '}{' '}
              <span
                style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}}
                className="requireFiled"
              >
                *
              </span>
            </label>
            <InputMask
              autocomplete="off"
              placeholder="HH:mm"
              className="form-control"
              mask="99:99"
              maskChar={null}
              value={this.props.fromHour}
              onChange={this.changeFromHour}
              beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}
            />
          </div>
        )}
        <div className="formComponent relativeComponent">
          <label className="labelComponent">
            {this.props.toLabel}
            <span style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}} className="requireFiled">
              *
            </span>
          </label>
          <InputMask
            autocomplete="off"
            id={this.props.toId}
            placeholder="yyyy/mm/dd"
            ref={(node) => (this.fromDate = node)}
            className="form-control"
            mask="9999/99/99"
            maskChar={null}
            value={this.state.toValue}
            onChange={this.onChangeTo}
            beforeMaskedValueChange={this.beforeMaskedValueChangeTo}
          />
          <img
            onClick={() => this.clearToDate()}
            src={require('../../image/close.svg')}
            style={{
              width: 20,
              position: 'absolute',
              top: 52,
              left: 15,
              cursor: 'pointer'
            }}
          />
        </div>
        {this.props.hasHour && (
          <div className="formComponent relativeComponent">
            <label className="labelComponent">
              {'ساعت تا : '}{' '}
              <span
                style={this.props.force ? {visibility: 'visible'} : {visibility: 'hidden'}}
                className="requireFiled"
              >
                *
              </span>
            </label>
            <InputMask
              autocomplete="off"
              placeholder="HH:mm"
              className="form-control"
              mask="99:99"
              maskChar={null}
              value={this.props.toHour}
              onChange={this.changeToHour}
              beforeMaskedValueChange={this.beforeMaskedValueChangeFrom}
            />
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default FromToPicker
